<template>
  <div>
    <div class="modal-overlay" @click.self="closeCashModal">
      <div class="modal-content">
        <div class="flex justify-between items-center mb-4">
          <h1>Cashout</h1>
          <img class="cursor-pointer" width="20" src="../icons/icon-close.svg" alt="" @click="closeCashModal" />
        </div>

        <div class="mb-2 relative">
          <div class="flex justify-between" v-for="(capft, index) in cashDetails" :key="index"
            :class="{ preTip: index == 1 }">
            <div class="flex justify-between items-center" :class="{ tip: index == 1 }">
              <h2>{{ capft.name }}</h2>
              <img v-if="capft.image" class="cursor-pointer" :src="capft.image" alt="" />
              <div class="tooltip-box">
                <p>
                  The standard payment cycle runs from Monday to Sunday. Your
                  payment processing and payout commence a day after the cycle.
                  <br />
                  <span>•</span> Standard payout: No fee <br />
                  <span>•</span> Instant cash-out: ₦200 processing fee
                </p>
              </div>
            </div>
            <!-- <h1>N{{ capft.amount }}</h1> -->
            <h1>
              <span v-if="capft.amount < 0">
                -₦ {{ formatAmount(Math.abs(capft.amount)) }}
              </span>
              <span v-else>
                ₦ {{ formatAmount(capft.amount) }}
              </span>
            </h1>
          </div>
        </div>

        <div class="mb-4">
          <div>
            <p>
              Transfers typically take a few minutes, however, you may
              experience up to a 24-hour delay depending on your bank.
            </p>
            <hr />
          </div>
        </div>

        <div class="mb-4">
          <div class="flex justify-between">
            <div>
              <h1>Weekly direct deposit <span>Typically every Monday and Tuesday</span></h1>
            </div>
            <div>
              <h2><span>No fee</span></h2>
              
            </div>
          </div>
        </div>

        <div class="mb-4 px-2 py-2">
        <p>Your default collection account is 0567887221 (Wema Bank)</p>
        </div>

        <div class="tooltip-wrapper">
          <div class="flex justify-end gap-2">
            <button class="py-2 px-4" @click="closeCashModal">Cancel</button>
            
            <button class="tooltip-button py-2 px-4" @click="requestCashOut()" :disabled="isDisabled">Cashout</button>
          </div>
          <span class="tooltip-text" v-if="isDisabled">
            Insufficient funds for cashout
          </span>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>

import cashTipIcon from '.././../../../../public/icons/cash-tip.svg';


export default {
  props: ["payout"],

  data() {
    return {
      payoutFee: 200,
    };
  },

  computed: {
    cashDetails() {
      return [
        { name: "CASHOUT AMOUNT", amount: this.payout },
        { name: "PAYOUT FEE", amount: this.payoutFee, image: cashTipIcon },
        { name: "TOTAL", amount: this.payout - this.payoutFee },
      ];
    },

    cashOutPayload() {
      return {
        type: "instant",
        userId: localStorage.getItem("userId"),
      };
    },

    isDisabled() {
      const total = this.payout - this.payoutFee;
      return total <= 0; 
    },
  },

  methods: {
    formatAmount(value) {
      return new Intl.NumberFormat('en-NG', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    closeCashModal() {
      this.$emit("close-cash-modal");
    },

     

    async requestCashOut() {
      try {
        let response = await this.$_cashOut(this.cashOutPayload);

        if (response.data.success === true) {
          this.generateToast(response.data.message, "success");
          this.closeCashModal();
          
        } else {
          this.generateToast(response.data.message, "error");
          this.closeCashModal();
        }
        
      } catch (error) {
        this.generateToast(
          error.response?.data?.message || "Something went wrong",
          "error"
        );
        this.closeCashModal();
      }
    },
  },
};
</script>


<style scoped>
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}
button:disabled {
  background-color: #ccc;
  /* cursor: not-allowed; */
  opacity: 0.7;
}

.tooltip-text {
  visibility: hidden;
  width: max-content;
  background-color: #10233e;
  color: #fff;
  text-align: center;
  font-size: 12px;
  border-radius: 4px;
  padding: 6px 8px;
  position: absolute;
  z-index: 1;
  bottom: -35px; /* Show under the button */
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}

 .tooltip-wrapper:hover .tooltip-text {
  visibility: visible;
} 



.tooltip-box {
  display: none;
  position: absolute;
  bottom: 60%;
  right: 0;
  width: 280px;
  background-color: #10233e;
  color: #F0F4FE;
  padding: 16px;
  border-radius: 8px;
  z-index: 999;
  font-size: 13px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
}

/* .tooltip-box h4 {
  margin: 10px 0 5px;
  font-size: 14px;
  font-weight: bold;
} */

span{
  margin: 10px 0 5px;
  font-size: 14px;
  font-weight: bold;
}

.tooltip-box p {
  font-weight: 400;
  margin: 0 0 10px;
  font-size: 12px;
  line-height: 1.4;
}

.modal-content>:nth-child(2)>div>.tip:hover .tooltip-box {
  display: block;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  /* align-items: center; */
  z-index: 9999;
}

.modal-content {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  max-width: 400px;
  width: 90%;
}

.modal-content>:nth-child(1) h1 {
  color: #10233E;
  font-size: 20px;
  font-weight: 600;
}

.modal-content>:nth-child(2) {
  background-color: #F7F7F7;
  border-radius: 8px;
  padding: 6%;
}
.modal-content>:nth-child(2)>div>.tip {
  /* border: 1px solid blue; */
  width: 33%;

}
.modal-content>:nth-child(2) h2 {
  color: #383F51;
  font-size: 12px;
  font-weight: 400;
}
.modal-content>:nth-child(2) h1 {
  color: #14171F;
  font-size: 16px;
  font-weight: 700;
}
.preTip{
 
  margin: 4% 0 4% 0;
}
.modal-content>:nth-child(3)>div p {
  color: #383F51;
  font-size: 12px;
  font-weight: 400;
}
.modal-content>:nth-child(3)>div hr {
  border: 0.5px solid #C2C7D6;
  margin-top: 3%;
}
.modal-content>:nth-child(4)>div>:nth-child(1) { 
  flex-basis: 65%;
}
.modal-content>:nth-child(4)>div>:nth-child(1) h1 {
  color: #14171F;
  font-size: 16px;
  font-weight: 400;
}
.modal-content>:nth-child(4)>div>:nth-child(1) span {
  color: #09B78A;
  font-size: 12px;
  font-weight: 400;
}
.modal-content>:nth-child(4)>div>:nth-child(2) h2 {
  color: #14171F;
  font-size: 16px;
  font-weight: 700;
}
.modal-content>:nth-child(4)>div>:nth-child(2) span {
   color: #7A90A7;
  font-size: 12px;
  font-weight: 600;
}

.modal-content>:nth-child(5) {
  border-radius: 8px;
  background-color: rgba(9, 183, 138, 0.06); 
}
.modal-content>:nth-child(5)>p {
  color: #09B78A;
  font-size: 12px;
  font-weight: 400;
}

.modal-content>:nth-child(6)>div>:nth-child(1) {
  color: #080056;
  font-size: 16px;
  font-weight: 700;
  /* border-radius: 5px; */
}
.modal-content>:nth-child(6)>div>:nth-child(2) {
  color: #10233E;
  font-size: 16px;
  font-weight: 700;
  background-color: #FCC210;
  border-radius: 5px;
}
</style>